<template>
    <div class="flex flex-col gap-1.5">
        <div class="flex flex-col">
            <vx-label size="md" class="mb-3">
                {{ props.field.name }}
                <vx-badge v-if="props.field.is_required" color="rose" size="xs">
                    Required
                    <font-awesome-icon widthAuto class="text-rose-500" :icon="faAsterisk"></font-awesome-icon>
                </vx-badge>
                <template v-if="props.field.description" v-slot:description>
                    {{ props.field.description }}
                </template>
            </vx-label>

            <vx-input
                v-model="model"
                :data-test="field.key"
                autofocus
                :name="field.key"
                size="lg"
                :error="displayFirstError(validation[field.key]?.$errors)"
                :counter="props.field.max_length !== null && props.field.max_length > 0"
                :minlength="props.field.min_length || 0"
                :maxlength="props.field.max_length || 1000"
                :minlengthWarning="props.field.min_length || 0"
            >
            </vx-input>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { VxLabel, VxInput, VxBadge } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAsterisk } from '@fortawesome/pro-solid-svg-icons';
import { displayFirstError } from '~/utils/validation';
import useVuelidate, { type ValidationArgs } from '@vuelidate/core';
import { minLength, maxLength, requiredIf } from '@vuelidate/validators';

const props = defineProps<{
    field: {
        id: number;
        key: string;
        name: string;
        description: string | null;
        is_required: boolean;
        min_length: number | null;
        max_length: number | null;
    };
    index: number;
}>();

const model = defineModel({ type: String });

const fieldValidationRules = computed<ValidationArgs<Record<string, string>>>(() => {
    return {
        [props.field.key]: {
            requiredIf: requiredIf(props.field.is_required),
            minLength: minLength(props.field.min_length || 0),
            maxLength: maxLength(props.field.max_length || 1000),
        },
    };
});

const validation = useVuelidate(
    fieldValidationRules,
    computed(() => ({ [props.field.key]: model.value }))
);
</script>
